/**
 * Forfait livraison par commande (zone ou prix fixe règle entreprise).
 * Aligné sur `OrderService.computeDeliveryCost` et `OrderFormPage`.
 */
export function computeDeliveryFee(
  serviceType: string,
  zoneDeliveryCost: number,
  customer: {
    enterpriseId?: string | null;
    indice?: number | null;
    enterprise?: {
      discountRules?: Array<{
        indexMin: number;
        indexMax: number;
        fixedDeliveryPrice?: number | null;
      }>;
    } | null;
  } | null,
): number {
  if (serviceType === "CATERING") return 0;
  let unitPrice = zoneDeliveryCost;
  if (
    customer?.enterpriseId &&
    customer.indice != null &&
    customer.enterprise?.discountRules?.length
  ) {
    const indice = Number(customer.indice);
    const rule = customer.enterprise.discountRules.find(
      (r) => indice >= r.indexMin && indice <= r.indexMax,
    );
    if (rule?.fixedDeliveryPrice != null && Number.isFinite(Number(rule.fixedDeliveryPrice))) {
      unitPrice = Number(rule.fixedDeliveryPrice);
    }
  }
  return Math.round(unitPrice * 100) / 100;
}
